import * as types from "./types";

export function inviteUsersStart(details, resend) {
  return {
    type: types.INVITE_USERS_START,
    details,
    resend
  };
}

export function fetchUsersListStart() {
  return {
    type: types.FETCH_USERS_LIST_START
  };
}

export function fetchUsersListSuccess(users) {
  return {
    type: types.FETCH_USERS_LIST_SUCCESS,
    users
  };
}

export function resendInvitationStart(email) {
  return {
    type: types.RESEND_INVITATION_START,
    email
  };
}

export function resendInvitationSuccess(email) {
  return {
    type: types.RESEND_INVITATION_SUCCESS,
    email
  };
}

export function resendInvitationFailed(email) {
  return {
    type: types.RESEND_INVITATION_FAILED,
    email
  };
}

export function resetAccountStatus(email) {
  return {
    type: types.RESET_INVITATION_ACCOUNT_STATUS,
    email
  };
}

export function inviteUsersFailure(msg) {
  return {
    type: types.INVITE_USERS_FAILURE,
    msg
  };
}

export function inviteUsersSuccess(invites) {
  return {
    type: types.INVITE_USERS_SUCCESS,
    invites
  };
}

export function deleteSubUserStart(mirrorID) {
  return {
    type: types.DELETE_SUBUSER_START,
    mirrorID
  };
}

export function deleteSubUserSuccess(mirrorID) {
  return {
    type: types.DELETE_SUBUSER_SUCCESS,
    mirrorID
  };
}

export function deleteSubUserFailed(mirrorID) {
  return {
    type: types.DELETE_SUBUSER_FAILED,
    mirrorID
  };
}

export function cancelUserInviteStart(inviteID) {
  return {
    type: types.CANCEL_SUBUSER_INVITE_START,
    inviteID
  };
}

export function copyToClipboard(status) {
  return {
    type: types.COPY_TO_CLIPBOARD,
    status
  };
}
